











































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Portfolio from "@/lib/models/Portfolio";
import User from "@/lib/models/User";
import PriceUpdate from "@/lib/models/PriceUpdate";
import dayjs from 'dayjs'
import {defaultCurrency} from "@/lib/models/sumbols";
import {formatInputPrice} from "@/lib/functions";

@Component({})
export default class EditPriceUpdateModal extends Vue {
    private $firebase: any;

    @Prop() portfolio?: Portfolio;
    @Prop() priceUpdate?: PriceUpdate;
    @Prop() user?: User;
    @Prop() collection?: firebase.database.ThenableReference;

    @Watch('priceUpdate')
    onChildChanged(val: PriceUpdate, oldVal: PriceUpdate) {
        this.priceUpdateToEdit = (new PriceUpdate()).fromObject(val) as PriceUpdate;
        this.date = dayjs(this.priceUpdateToEdit.date).toDate().toISOString();
        if ((!this.priceUpdateToEdit.id || this.priceUpdateToEdit.id.length === 0) && this.portfolio !== undefined) {
            this.priceUpdateToEdit.price = this.portfolio.latestUpdateValue()
        }
    }

    priceUpdateToEdit: PriceUpdate | null = null;
    isOpen: boolean = false;
    savingError: null | string = null;
    priceToAdd: number = 0;
    saveStyle: string = 'total';
    date: string = (new Date()).toString();
    validationErrors: { [k: string]: string } = {};

    get currency() {
        return this.portfolio && this.portfolio.currency ? this.portfolio.currency : (this.user ? this.user.currency : defaultCurrency);
    }

    toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            setTimeout(() => {
                if (this.$refs.priceInput) {
                    (this.$refs.priceInput as HTMLInputElement).focus();
                }
            }, 400);
        }
    }


    toggleSaveType() {
        this.saveStyle = this.saveStyle === 'total' ? 'add' : 'total';
        setTimeout(() => {
            if (this.$refs.priceInput) {
                (this.$refs.priceInput as HTMLInputElement).focus();
            }
        }, 300);
    }

    formatPrice() {

        if (this.priceUpdateToEdit) {
            this.priceUpdateToEdit.price = formatInputPrice(this.priceUpdateToEdit ? this.priceUpdateToEdit.price : 0) as unknown as number;

            if (this.saveStyle === 'add') {
                this.priceToAdd = formatInputPrice(this.priceToAdd) as unknown as number;
            }
        }
    }

    submitForm() {
        if (this.$refs.submitButton) {
            (this.$refs.submitButton as HTMLButtonElement).click();
        }
    }


    validate(): boolean {
        this.validationErrors = {};
        if (this.priceUpdateToEdit) {
            if (!this.priceUpdateToEdit.price || isNaN(this.priceUpdateToEdit.price)) {
                this.validationErrors['price'] = "Invalid price. Must be valid number.";
            }
            if (!this.priceUpdateToEdit.date || !dayjs(this.priceUpdateToEdit.date).isValid()) {
                this.validationErrors['date'] = "Invalid date.";
            }

            return Object.keys(this.validationErrors).length === 0;
        } else {
            return false;
        }
    }

    savePortfolio() {

        if (this.priceUpdateToEdit && this.user && this.portfolio && this.validate()) {
            this.savingError = null;
            const updates: { [k: string]: PriceUpdate } = {};

            this.priceUpdateToEdit.date = dayjs(this.date).format('YYYY-MM-DD HH:mm:ss');
            this.priceUpdateToEdit.price = parseFloat(String(this.priceUpdateToEdit.price)) + (this.saveStyle === 'add' ? parseFloat(String(this.priceToAdd)) : 0);

            if (this.priceUpdateToEdit.id && this.priceUpdateToEdit.id.length > 0) {
                updates[`portfolio/${this.user.uid}/${this.portfolio.id}/_priceUpdates/${this.priceUpdateToEdit.id}`] = this.priceUpdateToEdit;
                this.$firebase.database().ref().update(updates);
                this.$swal({
                    icon: 'success',
                    title: 'Successfully saved.',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                this.$firebase.database().ref(`portfolio/${this.user.uid}/${this.portfolio.id}/_priceUpdates`).push().set(this.priceUpdateToEdit).then(() => {
                    this.toggle();
                }, (err: any) => {
                    this.savingError = err.message;
                });
            }

        }
    }
}
